<template>
  <div class="error">
    <img :src="require('@/assets/common/error/error404.png')" alt="">
    <div class="content">
      <div class="text">哎呀，当前服务器地址不存在</div>
      <div>
        <van-button plain type="info" size="small" @click="close" style="margin-right:20px">返回上一页</van-button>
        <van-button type="info" round size="small" @click="submit">重新登录</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Error404',
    data () {
      return {}
    },
    created () {
      this.xy.unloading()
    },
    methods: {
      close () {
        this.$router.go(-1)
      },
      submit () {
        this.xy.removeCookie('.XYTOKEN')
        this.$router.replace({ path: '/login' })
      }
    }
  }
</script>
<style lang="less" scoped>
  .error{
    background: #fff;
    text-align: center;
    padding-top: 200px;
    height: 100%;
    img{
      width:90%;
      margin-bottom:100px;
    }
    .content{
      .text{
        margin-top:20px;
        margin-bottom:40px;
        font-size: 30px;
        color:rgba(0,0,0,0.45);
      }
    }
  }
</style>
